import {Component, OnInit} from '@angular/core';
import {ServerService} from '../service/server.service';
import {LoadingController, ModalController, NavController, ToastController} from '@ionic/angular';
import {AuthService} from '../service/auth.service';

@Component({
  selector: 'app-forgot',
  templateUrl: './forgot.page.html',
  styleUrls: ['./forgot.page.scss'],
})
export class ForgotPage implements OnInit {

  userId: any;
  newPassword = false;
  email: any;
  otp: any;
  otpValue: any;
  loading: any;
  optInput: number[] = [];
  flagGreen: boolean = false;
  showPassword: boolean;
  showOtp: boolean;
  isSms: boolean;
  selectedOption = false;


  constructor(public server: ServerService,
              public toastController: ToastController,
              private nav: NavController,
              public loadingController: LoadingController,
              private authService: AuthService,
              public modalController: ModalController,) {

  }

  async ngOnInit() {
    this.loading = await this.loadingController.create({
      message: '',
      spinner: 'bubbles',
      duration: 30000
    });

  }

  async verifyOtp() {
    this.loading.present();
    const body = {otp: this.optInput.join('')};
    this.otpValue = this.optInput.join('');
    this.authService.validateOtp(body, this.userId).subscribe((res: any) => {
      if (res) {
        this.newPassword = true;
      }
      this.loading.dismiss();
    }, error => {
      console.warn(error);
      this.loading.dismiss();
      this.presentToast('No fue posible verificar el otp');
    });
  }

  focusNext(event: KeyboardEvent, index: number) {
    const inputValue = (event.target as HTMLInputElement).value;
    const isBackspace = event.key === 'Backspace';

    if (isBackspace && index > 10) {
      const previousIndex = index - 1;
      const previousInput = document.querySelector(`input[tabindex="${previousIndex}"]`) as HTMLInputElement;
      if (previousInput) {
        previousInput.focus();
        previousInput.select();
      }
    } else if (inputValue && inputValue.length > 0) {
      const nextIndex = index < 15 ? index + 1 : index;
      const nextInput = document.querySelector(`input[tabindex="${nextIndex}"]`) as HTMLInputElement;
      if (nextInput) {
        nextInput.focus();
        nextInput.select();
      }
    }
  }

  manejarPegado(event: ClipboardEvent ) {
    event.preventDefault();
    const pastedText = event.clipboardData?.getData('text/plain') || 
                       (window as any).clipboardData?.getData('text/plain');
    if (pastedText) {
      const characters = pastedText.split('');
      for (let i = 0; i < characters.length && i < 6; i++) {
        this.optInput[i] = characters[i];
        const currentIndex = i + 1;
        const currentInput = document.querySelector(`input[tabindex="${currentIndex}"]`) as HTMLInputElement;
        if (currentInput) {
          currentInput.focus();
        }      
      }
    }
  }
  
  async updatePassword(data) {
    if (data.password.length == 0) {
      this.presentToast('La contraseña es muy corta');
    } else if (data.password != data.confirmPassword) {
      this.presentToast('Las contraseñas no coinciden');
    } else {
      this.loading.present();
      data.otp = this.otpValue;
      this.authService.recoverPassword(this.userId, data).subscribe((res: any) => {
        console.log(res);
        this.presentToast('Contraseña actualizada con éxito');
        setTimeout(() => {
          this.loading.dismiss();
          window.location.href = '/login';
        }, 2000);
      },error => {
        this.presentToast('No fue posible actualizar la contraseña');
        console.warn(error);
      });
    }
  }

  async presentToast(txt) {
    const toast = await this.toastController.create({
      message: txt,
      duration: 3000,
      position: 'top',
      mode: 'ios',
      color: 'dark'
    });
    toast.present();
  }


  findUserByDocument(form: any) {
    return this.authService.findByDocument(form.document).toPromise();
  }

  async close(data?: any) {
    await this.modalController.dismiss(data);
  }


  async continueAction(from: any) {
    const userResponse: any = await this.findUserByDocument(from);
    if (userResponse && userResponse.length > 0) {
      this.userId = userResponse[0].userId;
    } else if (userResponse) {
      await this.presentToast('Datos no válidos');
    }
    if (from.list === "otp") {
      this.showOtp = true;
    } else if (from.list === "message") {
      this.sendOtp({isSms: true});
    } else if (from.list === "ws") {
      this.sendOtp({isWhatsApp: true});
    } else if (from.list === "email") {
      this.sendOtp({isEmail: true});
    }else if(from.list === ""){
      await this.presentToast('Selecciona una opción');
    } 
   }

  sendOtp(body: any) {
    this.loading.present();
    this.authService.sendOtp(this.userId, body).subscribe((res: any) => {
      this.showOtp = true;
      this.loading.dismiss();
    }, error => {
      this.presentToast('Error al enviar codigo');
      setTimeout(() => {
        this.loading.dismiss();
       // window.location.href = '/login';
       this.userId=null;
      }, 2000);    });
  }

  isLowerCaseValid(form): boolean {
    console.log(form);
    const password = form.password;
    console.log(password);
    console.log(/[a-z]/.test(password));
    return /[a-z]/.test(password);

  }

  isUpperCaseValid(form): boolean {
    const password = form.password;
    return /[A-Z]/.test(password);
  }

  isNumberValid(form): boolean {
    const password = form.password;
    return /\d/.test(password);
  }

  isSpecialCharacterValid(form): boolean {
    const password = form.password;
    return /[$#*-]/.test(password);
  }

}

